import * as React from "react";
import { useParams, useHistory } from "react-router";
import { ImportXmlApi } from "../../../api/ImportXmlApi";
import { useAuth } from "../../../App";
import { SpinnerWrapper, CustomButton, ButtonType } from "soprasteria-ui-library";
import { IImportedXmlDetails } from "../../../models/IImportedXml";
import { ImportedXmlDetailsRowTable } from "./ImportedXmlDetailsRowTable";
import { setMessage } from "../../../helpers/MessageHelper";
import { ImportedXmlDetailsInformation } from "./ImportedXmlDetailsInformation";

export const ImportedXmlDetails: React.FunctionComponent<{}> = () => {
    const { importedXmlId } = useParams<{importedXmlId: string}>();
    const { careProviderId } = useParams<{careProviderId: string}>();
    const history = useHistory();
    const auth = useAuth();
    const api = new ImportXmlApi(auth);

    const [importedXml, setImportedXml] = React.useState<IImportedXmlDetails>();
    const [isLoading, setIsLoading] = React.useState<boolean>(false);
    const [isExportingToExcel, setIsExportingToExcel] = React.useState<boolean>(false);
    const [errorMessage, setErrorMessage] = React.useState<string>("");

    React.useEffect(() => {
        if (importedXmlId) {
            setIsLoading(true);
            api.getImportedXml(importedXmlId, false, careProviderId, (data) => {
                setImportedXml(data);
            }, undefined,
                (message) => {
                    changeErrorMessage(message);
                }, () => setIsLoading(false));
        }
    }, [, importedXmlId]);

    const changeErrorMessage = (message: string) => {
        const newMessage = setMessage(message, errorMessage ?? "");
        setErrorMessage(newMessage);
    }

    const exportListToExcel = () => {
        if (importedXmlId) {
            setIsExportingToExcel(true);
            api.getImportedXml(importedXmlId, true, careProviderId, undefined, "Rader i importfil",
                (message) => {
                    changeErrorMessage(message);
                }, () => setIsExportingToExcel(false));
        }
    }

    return (
        <>
            <section className="card">
                <div className="card-header">
                    <h1>Visar importerad fil</h1>
                </div>
                <SpinnerWrapper isLoading={isLoading}>
                    <div className="card-body">
                        <ImportedXmlDetailsInformation importedXml={importedXml} changeErrorMessage={changeErrorMessage} />
                        <br />
                        {
                            importedXml?.importedXmlRows && importedXml.importedXmlRows.length > 0 ?
                                <div className="text-right">
                                    <CustomButton buttonType={ButtonType.excel} isLoading={isExportingToExcel} buttonText="Exportera till excel" onClick={() => exportListToExcel()} />
                                </div>
                                : null
                        }
                        <ImportedXmlDetailsRowTable importedXmlRows={importedXml?.importedXmlRows ?? []} />
                    </div>
                    <div className="card-footer">
                        <div className="row">
                            <div className="col-6 text-left">
                                <CustomButton buttonType={ButtonType.general} onClick={() => history.goBack()} buttonText="Gå tillbaka" />
                            </div>
                        </div>
                    </div>
                </SpinnerWrapper>
            </section>
        </>
    );
}